import { Component, Injector, OnInit } from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { EventService } from '../../../services/event.service';
import { FacebookFundraiserService } from '../../../services/facebook-fundraiser.service';
import { BaseDialogComponent } from '../base-dialog/base-dialog.component';

@Component({
    selector: 'facebook-confirmation-dialog',
    templateUrl: './facebook-confirmation-dialog.component.html'
})
export class FacebookconfirmationDialogComponent extends BaseDialogComponent implements OnInit {
    messages: string[] = [];
    messengerUrl: string;

    constructor(
        public activeModal: NgbActiveModal,
        public facebookFundraiserService: FacebookFundraiserService,
        public eventService: EventService,
        injector: Injector
    ) {
        super(injector);
    }

    ngOnInit(): void {
        const selectedEvent = this.eventService.selectedEvent;
        const participant = selectedEvent.gql.Participant[0];
        this.facebookFundraiserService.getFacebookMessengerLink(
          participant.event.program.name,
          participant.event.program.programGroup.name
        ).subscribe((res: any) => {
            this.messengerUrl = res ? res.url : null;
        });
    }

    public closeConfirmationDialog() {
        this.activeModal.close();
    }

    public openMessengerUrl() {
        window.open(this.messengerUrl, '_blank');
    }
}
